<div class="spacer-page">
  <p-panel>
    <!-- <div class="grid">
      <div class="col-12 md:col-6 lg:col-12">
        <div class="stacked-content">
          <p-header class="section-header">ALLO - The Data Extract Module</p-header>
        </div>
      </div>
    </div> -->

    <div class="tabs-list">
      <div class="tab-item" [ngClass]="{'active': activeTab === 'alloProperties'}"
        (click)="setActiveTab('alloProperties')">
        Property Manager
      </div>
      <div class="tab-item" [ngClass]="{'active': activeTab === 'alloExport'}" (click)="setActiveTab('alloExport')">
        Data Extract Manager
      </div>
      <!-- <div class="tab-item" [ngClass]="{'active': activeTab === 'rateMaster'}" (click)="setActiveTab('rateMaster')">
        APR Rate Master
      </div> -->
      <div class="tab-item" [ngClass]="{'active': activeTab === 'userHistory'}" (click)="setActiveTab('userHistory')">
        User History
      </div>
    </div>

    <div *ngIf="activeTab === 'alloProperties'">
      <app-allo-properties></app-allo-properties>      
    </div>
    <div *ngIf="activeTab === 'alloExport'">
      <app-allo-reports></app-allo-reports>
    </div>
    <!-- <div *ngIf="activeTab === 'rateMaster'">
      <app-allo-rate-master></app-allo-rate-master>
    </div> -->
    <div *ngIf="activeTab === 'userHistory'">
      <app-allo-history></app-allo-history>
    </div>
    <div *ngFor="let msg of errMsgs">
      <p-message [severity]="msg.severity" [text]="msg.summary" [closable]="true"></p-message>
    </div>
  </p-panel>
</div>
